<template>
  <div>
    <v-layout row container justify-center>
      <v-dialog v-model="dialog" persistent max-width="1500">
        <v-card light class="pr-5 pl-5 pt-4 pb-4">
          <span class="subheadline">Presentación Nueva</span>
            <v-layout row wrap class="item-group">
              <v-flex>
                <v-autocomplete v-model="definicion" label="Definicion Presentación" required :error-messages="getRequiredErrors('definicion')"
                        :items="definiciones" item-text="nombre" item-value="pk"></v-autocomplete>
                <span style="color: rgb(255 106 13);" v-if="showLabelCargaLpf">La presentación seleccionada únicamente podrá ser cargada por la LPF</span>
                <v-autocomplete v-model="categoriasSeleccionadas" label="Categoría" required :error-messages="getRequiredErrors('categoriasSeleccionadas')"
                        multiple :items="categorias" item-text="description" item-value="id">
                 <v-list-tile slot="prepend-item" ripple @click="selectAllCategories()">
                <v-list-tile-action></v-list-tile-action>
                <v-list-tile-title>Seleccionar todas</v-list-tile-title>
              </v-list-tile>
              <v-divider slot="prepend-item"></v-divider>
                </v-autocomplete>
                <v-autocomplete v-model="clubesSeleccionados" label="Clubes" required :error-messages="getRequiredErrors('clubesSeleccionados')"
                        multiple :items="clubes" item-text="nombre" item-value="pk">
                 <v-list-tile slot="prepend-item" ripple @click="selectAll()">
                <v-list-tile-action></v-list-tile-action>
                <v-list-tile-title>Seleccionar todos</v-list-tile-title>
              </v-list-tile>
              <v-divider slot="prepend-item"></v-divider>
                </v-autocomplete>
                <DatePickerForm v-model="fechaInicioCarga" label="Período de la presentación" showLabel
                :error-messages="getRequiredErrors('fechaInicioCarga')"></DatePickerForm>
              </v-flex>
            </v-layout>
          <v-card-actions>
            <v-btn color="primary" @click="closeDialog">Volver</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="submit">Crear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>

import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { createEntityMixin } from '../../../mixins/createEntityMixin'
import DatePickerForm from '../../../common/ui/DatePickerForm'

export default {
  mixins: [validationMixin, createEntityMixin],

  validations: {
    clubesSeleccionados: { required },
    definicion: { required },
    fechaInicioCarga: { required },
    fechaVencimiento: { required },
    categoriasSeleccionadas: { required }
  },

  components: {
    DatePickerForm
  },

  data () {
    return {
      dialog: false,
      createPath: 'presentacion/create',
      isEditing: false,
      fechaInicioCarga: null,
      fechaVencimiento: '2100-01-01',
      definicionPresentacion: null,
      clubes: [],
      definiciones: [],
      clubesSeleccionados: [],
      definicion: null,
      showLabelCargaLpf: false,
      categorias: [],
      categoriasSeleccionadas: []
    }
  },
  methods: {
    selectAll () {
      if (this.clubesSeleccionados.length === this.clubes.length) {
        this.clubesSeleccionados = []
      } else {
        this.clubesSeleccionados = this.clubes.map(x => x.pk)
      }
      this.$forceUpdate()
    },
    fetchClubes (categoriasSeleccionadas) {
      this.clubes = []
      if (!categoriasSeleccionadas || categoriasSeleccionadas.length === 0) {
        this.clubes = []
        return
      }

      const categoriaIds = categoriasSeleccionadas.join(',')
      this.axios
        .get(`clubes?categories=${categoriaIds}`)
        .then(response => {
          this.clubes = response.data
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    fetchDefiniciones () {
      this.axios
        .get('definiciones?cargaLpf=true')
        .then(response => {
          this.definiciones = response.data
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    isValidForm () {
      return !this.$v.$invalid
    },
    postSuccessfulSubmit () {
      this.$router.go()
      this.closeDialog()
    },
    getPayload () {
      return {
        'clubes': this.clubesSeleccionados,
        'definicionPresentacion': this.definicion,
        'fechaCarga': this.fechaInicioCarga,
        'fechaVencimiento': this.fechaVencimiento
      }
    },
    showDialog () {
      this.dialog = true
    },
    closeDialog () {
      this.dialog = false
    },
    fetchCategorias () {
      this.axios
        .get('informe-auditoria/categorias')
        .then(response => {
          this.categorias = response.data
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    selectAllCategories () {
      if (this.categoriasSeleccionadas.length === this.categorias.length) {
        this.categoriasSeleccionadas = []
      } else {
        this.categoriasSeleccionadas = this.categorias.map(x => x.id)
      }
      this.$forceUpdate()
    }
  },
  created () {
    this.fetchCategorias()
    this.fetchDefiniciones()
  },
  watch: {
    'definicion' () {
      this.definiciones.map((e) => {
        if (e.pk === this.definicion) {
          if (e.cargaLpf) {
            this.showLabelCargaLpf = true
          } else {
            this.showLabelCargaLpf = false
          }
        }
      })
    },
    'categoriasSeleccionadas' (newCategorias, oldCategorias) {
      this.fetchClubes(newCategorias)
    }
  }
}
</script>

<style>
.subheadline {
  color: lightslategray;
  font-size: 1.6em;
  color: rgb(60, 145, 197);
  padding-top: 1.5em;
  margin-top: 2em;
}
</style>
